export const portalIt = {

  // ── Onboarding survey (/portal/onboarding) ───────────────────────────────
  onboarding: {
    title: "Benvenuto — come possiamo aiutarti?",
    subtitle: "Dicci cosa ti porta qui così possiamo indirizzarti nel posto giusto.",
    later: "Lo farò più tardi",
    back: "Indietro",
    choices: {
      applyTitle: "Richiedi Thailand Elite : visto Thailand Privilege",
      applyDesc: "Inizia la tua domanda di adesione / visto di lungo soggiorno.",
      memberTitle: "Sono già membro Thailand Elite",
      memberDesc: "Collega la tua iscrizione o richiedi servizi per i membri.",
      prospectTitle: "Ho domande prima di decidere",
      prospectDesc: "Ricevi informazioni e parla con un consulente.",
      partnerTitle: "Rappresento un'agenzia o un partner",
      partnerDesc: "Scopri le opzioni di partnership e referral.",
      otherTitle: "Qualcos'altro",
      otherDesc: "Un altro tipo di richiesta — dicci come possiamo aiutarti.",
      servicesTitle: "Immobili, assicurazioni e altri servizi",
      servicesDesc: "Immobili, assicurazione, un altro visto o aiuto per stabilirti in Thailandia.",
    },
    applicant: {
      heading: "Un paio di domande veloci",
      subtitle: "Ci aiuta a personalizzare la tua domanda. Potrai modificarlo in seguito.",
      purposeLabel: "Qual è il motivo principale per cui scegli Thailand Elite?",
      timelineLabel: "Quando prevedi di fare domanda o trasferirti?",
      submit: "Continua con la mia domanda",
    },
    purpose: {
      retirement: "Pensione / soggiorno lungo",
      business: "Affari / lavoro",
      family: "Famiglia / familiari a carico",
      investment: "Investimento",
      lifestyle: "Stile di vita / viaggi frequenti",
      other: "Altro",
    },
    timeline: {
      asap: "Il prima possibile",
      m1_3: "Entro 1–3 mesi",
      m3_6: "Tra 3–6 mesi",
      m6_12: "Tra 6–12 mesi",
      exploring: "Mi sto solo informando",
    },
    member: {
      heading: "Bentornato — troviamo la tua iscrizione",
      subtitle: "Indica il tuo numero di membro e il nostro team lo collegherà a questo account dopo una rapida verifica.",
      idLabel: "Numero membro / tessera",
      idPlaceholder: "es. TPC123456",
      sinceLabel: "Da quando sei membro?",
      sincePlaceholder: "es. 2022",
      viaLabel: "Come hai fatto domanda?",
      viaPlaceholder: "Agente, diretto, ecc.",
      helpLabel: "Come possiamo aiutarti?",
      helpPlaceholder: "Descrivi la tua richiesta (apposizione del visto, notifica 90 giorni, rinnovo…).",
      submit: "Invia",
    },
    inquiry: {
      heading: "Raccontaci qualcosa in più",
      subtitle: "Inoltreremo la tua richiesta alla persona giusta e ti ricontatteremo.",
      typeLabel: "Di cosa tratta la tua richiesta?",
      messageLabel: "Il tuo messaggio",
      messagePlaceholder: "Dicci come possiamo aiutarti.",
      submit: "Invia richiesta",
    },
    inquiryTypes: {
      general_inquiry: "Domanda generale",
      member_service: "Membro esistente — richiesta di servizio",
      partnership: "Agenzia / partnership",
      visa_other: "Altra domanda su visto / immigrazione",
      other_services: "Immobili, assicurazioni o altri servizi",
      other: "Altro",
    },
    services: {
      heading: "Come possiamo aiutarti?",
      subtitle: "Seleziona tutto ciò che ti interessa — ti metteremo in contatto con il partner giusto.",
      interestsLabel: "Mi interessa",
      messageLabel: "Vuoi aggiungere qualcosa?",
      messagePlaceholder: "Es. cerco un condominio a Bangkok, un'assicurazione sanitaria per due…",
      submit: "Invia",
      needInterestTitle: "Scegli almeno un'opzione",
      needInterestDesc: "Dicci cosa ti interessa.",
    },
    interests: {
      real_estate: "Immobili",
      insurance: "Assicurazione sanitaria / di viaggio",
      other_visa: "Un altro visto",
      business_setup: "Apertura di un'attività",
      relocation: "Aiuto al trasferimento (scuole, banca…)",
      extraLabel: "Possiamo aiutarti con altro in Thailandia?",
    },
    deleteAccount: {
      link: "Hai creato questo account per errore? Eliminalo",
      title: "Eliminare il tuo account?",
      desc: "Il tuo account e le informazioni inserite verranno eliminati definitivamente. L'operazione è irreversibile.",
      confirm: "Elimina il mio account",
      cancel: "Annulla",
      doneTitle: "Account eliminato",
      doneDesc: "Il tuo account è stato eliminato. Sarai sempre il benvenuto.",
      failedTitle: "Impossibile eliminare l'account",
      notEligible: "Questo account ha una domanda o un'iscrizione. Scrivici e lo chiuderemo per te.",
    },
    done: {
      title: "La tua richiesta è stata inviata",
      desc: "Grazie — il nostro team la esaminerà e ti contatterà a breve.",
      cta: "Vai alla mia dashboard",
    },
    optionalTag: "(facoltativo)",
    memberOutcome: {
      linkedTitle: "Iscrizione collegata ✓",
      linkedDesc: "Bentornato — la tua area membri è pronta.",
      pendingTitle: "Ci siamo quasi — conferma la tua iscrizione",
      pendingDesc: "Abbiamo inviato una conferma alla tua email registrata ({{email}}). Una volta confermata e approvata dal nostro team, la tua iscrizione sarà collegata.",
    },
    banner: {
      memberTitle: "Grazie — stiamo verificando la tua iscrizione",
      memberDesc: "Il nostro team collegherà a breve il tuo numero di membro a questo account. Riceverai una notifica una volta confermato.",
      prospectTitle: "Grazie per averci contattato",
      prospectDesc: "Un consulente ti ricontatterà con le informazioni richieste. Pronto a fare domanda? Puoi iniziare in qualsiasi momento qui sotto.",
      partnerTitle: "Grazie per il tuo interesse a collaborare",
      partnerDesc: "Pronto a collaborare con noi? Invia il profilo della tua azienda per iniziare — oppure il nostro team partnership ti contatterà.",
      partnerCta: "Diventa partner",
      otherTitle: "La tua richiesta è stata ricevuta",
      otherDesc: "Il nostro team la esaminerà e ti ricontatterà a breve.",
    },
    toast: {
      saveFailedTitle: "Impossibile salvare",
      saveFailedDesc: "Riprova.",
      applicantOkTitle: "Ottimo — iniziamo",
      applicantOkDesc: "Ora puoi iniziare la tua domanda.",
      needMessageTitle: "Aggiungi un breve messaggio",
      needMessageDesc: "Dicci come possiamo aiutarti.",
    },
  },
  common: {
    saveAndContinue: "Salva e continua",
    back: "Indietro",
    submit: "Invia domanda",
    submitting: "Invio in corso…",
    saving: "Salvataggio…",
    uploading: "Caricamento…",
    required: "Obbligatorio",
    optional: "facoltativo",
    yes: "Sì",
    no: "No",
    select: "Seleziona…",
    uploaded: "Caricato",
    missing: "Mancante",
    loading: "Caricamento…",
    download: "Scarica",
    upload: "Carica",
    remove: "Rimuovi",
    retry: "Riprova",
    next: "Avanti",
    close: "Chiudi",
    addDocuments: "Aggiungi documenti",
    signOut: "Esci",
    memberPortal: "Area soci",
    language: "Lingua",
    // Toast messages
    fileTooLarge: "File troppo grande",
    maxSizeAllowed: "Massimo {{size}} consentito.",
    uploadFailed: "Caricamento fallito",
    invalidEmail: "Email non valida",
  },

  dashboard: {
    nextMemberApp: "Domanda Membro Associato",
    addNextMember: "Aggiungi membro associato",
    nextMemberPromo: "Promozione: 750.000 THB per membro associato fino al 31/12/2026",
    myApplications: "Le mie domande",
    noApplications: "Nessuna domanda",
    noApplicationsDesc: "Inizia il tuo percorso Thailand Elite creando la tua prima domanda.",
    createApplication: "Crea domanda",
    newApplication: "Nuova domanda",
    resumeApplication: "Riprendi domanda",
    alreadyActiveTitle: "Domanda già in corso",
    alreadyActiveDesc: "Hai già una domanda attiva. Completa o annulla quella esistente prima di crearne una nuova.",
    package: "Programma",
    created: "Creata il",
    messages: "Messaggi",
    newThread: "Nuovo thread",
    newThreadSubject: "Oggetto",
    newThreadBody: "Messaggio",
    generalInquiry: "Richiesta generale",
    noMessages: "Nessun messaggio",
    status: {
      open: "Aperto",
      waiting_reply: "In attesa di risposta",
      closed: "Chiuso",
      draft: "Bozza",
      submitted: "Inviata",
      under_review: "In esame",
      background_check: "Verifica precedenti",
      approved: "Approvata",
      payment_pending: "Pagamento in attesa",
      payment_done: "In attesa di attivazione",
      active: "Attiva",
      cancelled: "Annullata",
      rejected: "Rifiutata",
    },
  },

  // ── Member Area ──────────────────────────────────────────────────────────
  membership: {
    card: {
      sectionTitle: "La tua tessera di socio",
      tierLabel:    "Adesione",
      holderLabel:  "Titolare della tessera",
      numberLabel:  "Numero tessera",
      validFrom:    "Valida dal",
      validUntil:   "Valida fino al",
      printOrSave:  "Stampa o salva come PDF",
    },
    documents: {
      lettersTitle:                "Lettere ufficiali",
      welcomeLetter:               "Lettera di benvenuto",
      welcomeLetterDesc:           "La tua lettera di benvenuto ufficiale Thailand Elite",
      welcomeLetterPending:        "Sarà caricata dal tuo agente al momento della conferma dell'attivazione",
      certificationLetter:        "Lettera di certificazione",
      certificationLetterDesc:    "Documento di certificazione ufficiale Thailand Privilege",
      certificationLetterPending: "Disponibile una volta emessa da Thailand Privilege",
      pending:                    "In attesa",
    },
  },

  // ── Member Services / Service Requests ───────────────────────────────────
  services: {
    tabLabel:           "Servizi",
    title:              "Servizi per i soci",
    intro:              "Invia una richiesta di servizio — apposizione del visto, notifica dei 90 giorni o qualsiasi altra richiesta. Il tuo numero di socio viene allegato automaticamente.",
    chooseType:         "Scegli un servizio",
    noTypes:            "Nessun tipo di servizio disponibile al momento. Contatta l'assistenza.",
    estimated:          "~{{days}} giorni lavorativi",
    history:            "Le tue richieste precedenti",
    back:               "Torna ai servizi",
    requirementsTitle:  "Cosa devi fornire",
    memberIdLabel:      "Invio come",
    subject:            "Oggetto",
    messageLabel:       "Descrivi la tua richiesta",
    messagePlaceholder: "Aggiungi tutti i dettagli che ci aiuteranno a elaborare la tua richiesta più rapidamente.",
    attachments:        "Allegati",
    addFile:            "Clicca per caricare (PDF / JPG / PNG, max 10 MB)",
    send:               "Invia richiesta",
    submittedTitle:     "Richiesta inviata",
    submittedDesc:      "Il nostro team Servizi per i soci la esaminerà e risponderà tramite Messaggi.",
    submittedDescMcc:      "Il nostro team la esaminerà e risponderà tramite Messaggi. Per un'elaborazione più rapida, invii qui sotto l'e-mail già pronta al MCC.",
    mcc: {
      title: "Contattare direttamente l'MCC",
      intro: "Il Member Contact Center (MCC) di Thailand Privilege prenota questo servizio. Invii questa e-mail già pronta in inglese dalla sua casella di posta: noi ne riceviamo una copia e seguiamo la pratica per lei.",
      titleNext: "Acceleri la sua richiesta: scriva al MCC",
      recommended: "Consigliato · elaborazione più rapida",
      oneMinute: "Richiede un minuto: l'e-mail è pronta, basta inviarla.",
      attachReminder: "I suoi documenti non vengono allegati automaticamente (privacy). Li alleghi alla sua e-mail: {{files}}",
      linksIncluded: "I suoi documenti sono inclusi nell'e-mail come link sicuri (validi fino al {{date}}). Può anche allegarli.",
      copyTip: "Suggerimento: usi «Copia l'e-mail» e la incolli nella sua casella, i nomi dei file diventano link cliccabili.",
      emailButton: "Scrivi all'MCC",
      gmailButton: "Apri in Gmail",
      callButton: "Chiama l'MCC",
      copyButton: "Copia l'e-mail",
      copied: "E-mail copiata.",
      preview: "Mostra l'e-mail",
      hidePreview: "Nascondi l'e-mail",
      confirmEmailTitle: "Ha inviato la sua e-mail all'MCC?",
      confirmPhoneTitle: "È riuscito a contattare l'MCC?",
      confirmHint: "L'MCC di solito risponde entro poche ore. Per le richieste urgenti, invii l'e-mail e chiami anche il {{phone}}.",
      yes: "Sì",
      notYet: "Non ancora",
      statusEmail: "Ha scritto all'MCC il {{date}}.",
      statusPhone: "Ha chiamato l'MCC il {{date}}.",
      copyReceived: "Abbiamo ricevuto la copia della sua e-mail.",
      followupTitle: "Ha ricevuto una risposta dall'MCC?",
      answered: "Sì, tutto risolto",
      needHelp: "No, ho bisogno di aiuto",
      thanks: "Grazie, preso nota.",
      helpSent: "Ce ne occupiamo noi: il nostro team solleciterà l'MCC per lei.",
      packageTitle: "La sua membership: {{package}}",
      privilegePoints: "Punti Privilege",
      privilegeBook: "Privilege Book 2026 (PDF)",
      mccLine: "Member Contact Center: {{email}} · {{phone}}",
      done: "Fatto",
    },
    details: {
      whereTitle: "Dove desidera far apporre il visto?",
      airport: "In aeroporto, all'arrivo",
      airportHint: "Arrivo almeno 7 giorni dopo oggi. Tenga pronto il biglietto aereo.",
      chaeng: "All'Immigrazione di Chaeng Watthana, Bangkok",
      chaengHint: "Un giorno lavorativo, almeno 5 giorni lavorativi dopo oggi. È richiesta una copia del TM30.",
      arrivalAirport: "Aeroporto di arrivo",
      flightNumber: "Numero di volo",
      departureFrom: "In partenza da",
      departurePlaceholder: "es. Milano MXP",
      arrivalDate: "Data di arrivo",
      arrivalTime: "Orario di arrivo (locale)",
      ticket: "Biglietto aereo o itinerario",
      ticketHint: "PDF o foto. Verifichiamo che corrisponda al volo indicato sopra.",
      ticketChecking: "Verifica del biglietto…",
      ticketMatch: "Biglietto verificato: volo e data corrispondono.",
      ticketMismatch: "Controlli il biglietto:",
      ticketUnreadable: "Non siamo riusciti a leggere il biglietto automaticamente. Il nostro team lo verificherà.",
      preferredDate: "Data preferita",
      period: "Fascia oraria",
      morning: "Mattina (9:00–12:00)",
      afternoon: "Pomeriggio (13:00–16:00)",
      alternativeDate: "Seconda scelta (facoltativa)",
      tentative: "Le date sono indicative e confermate da Member Services in base alla disponibilità.",
      tm30: "Copia del TM30 (prova di residenza)",
      tm30Hint: "La ricevuta TM30 del proprietario o dell'hotel.",
      passportCopy: "Copia del passaporto (pagina con foto)",
      passportHint: "Il passaporto in cui verrà apposto il visto. Se ha un nuovo passaporto, carichi quello.",
      passportFromApplication: "Dalla sua domanda",
      useApplicationPassport: "Usa il passaporto della mia domanda",
      passportNewWarning: "Non è il passaporto usato per la domanda. Con un nuovo passaporto l'Immigrazione potrebbe dover ripetere il controllo dei precedenti prima di apporre il visto, il che può richiedere più tempo. Le faremo sapere se serve altro.",
      tm30Guide: "Che cos'è il TM30?",
      upload: "Carica",
      replace: "Sostituisci",
      bank: "Banca",
      bankPlaceholder: "Scegli una banca",
      city: "Città",
      branch: "Filiale (facoltativa)",
      branchPlaceholder: "es. Silom, Central World",
      bankHint: "La decisione finale spetta alla banca, che può richiedere altri documenti.",
      ninetyTitle: "Il rapporto dei 90 giorni",
      ninetySummary: "Il modulo TM47 conferma il suo indirizzo ogni 90 giorni di soggiorno continuativo. Uscire dalla Thailandia azzera il conteggio. Si può presentare da 15 giorni prima a 7 giorni dopo la scadenza; il ritardo comporta una multa di 2.000 THB.",
      readGuide: "Leggi la guida completa",
      messageOptional: "Altro da segnalarci?",
      noMessage: "Vedi i dettagli qui sotto.",
      licenseType: "Tipo di patente",
      car: "Auto",
      motorcycle: "Moto",
      both: "Auto e moto",
      office: "Ufficio del Department of Land Transport",
      chatuchak: "Chatuchak, Bangkok",
      otherOffice: "Altro ufficio",
      otherOfficePlaceholder: "Città / ufficio",
      homeLicense: "La sua patente del Paese d'origine, in corso di validità",
      residenceCertificate: "Certificato di residenza",
      residenceCertificateHint: "Rilasciato dalla sua ambasciata (oppure un permesso di lavoro).",
      medicalCertificate: "Certificato medico",
      medicalCertificateHint: "Di una clinica in Thailandia, rilasciato nell'ultimo mese. Si può ottenere anche prima dell'appuntamento.",
      drivingIntro: "Si fa in un giorno al Department of Land Transport con il nostro accompagnatore. Porti il passaporto con il visto Privilege.",
      drivingGuide: "Guida alla patente",
      epaService: "Servizio",
      epaArrival: "Arrivo",
      epaDeparture: "Partenza",
      epaAirport: "Aeroporto",
      flightDate: "Data del volo",
      flightTime: "Orario del volo (locale)",
      originCity: "Città di provenienza",
      originCityPlaceholder: "es. Milano",
      passengers: "Numero di passeggeri",
      epaHint: "L'EPA è attivo dalle 6:00 alle 24:00. Prenoti almeno 5 ore prima del volo.",
      optional: "facoltativo",
      docType: "Tipo di documento",
      docTypes: {
        passport: "Passaporto",
        visa_page: "Pagina del visto",
        photo: "Foto",
        entry_stamp: "Timbro d'ingresso",
        tm30: "TM30",
        flight_ticket: "Biglietto aereo",
        home_license: "Patente (Paese d'origine)",
        residence_certificate: "Certificato di residenza",
        medical_certificate: "Certificato medico",
        other: "Altro documento",
      },
      phone: "Numero di telefono (per l'MCC)",
      phoneHint: "Dal suo profilo. Può modificarlo.",
      fromApplication: "Aggiungi dalla mia domanda",
      fromApplicationHint: "Documenti già caricati con la sua domanda. Non serve caricarli di nuovo.",
      appDocs: {
        passport_photo: "Pagina foto del passaporto",
        passport_signature: "Pagina firma del passaporto",
        visa: "Pagina del visto",
        arrival_stamp: "Timbro d'ingresso",
        profile_photo: "Foto",
        marriage_certificate: "Certificato di matrimonio",
        birth_certificate: "Certificato di nascita",
      },
      errors: {
        licenseTypeRequired: "Scelga il tipo di patente.",
        officeRequired: "Scelga l'ufficio.",
        homeLicenseRequired: "Carichi la patente del suo Paese d'origine.",
        residenceCertificateRequired: "Carichi il certificato di residenza.",
        epaServiceRequired: "Scelga arrivo o partenza.",
        flightDateRequired: "Inserisca la data del volo.",
        flightDatePast: "La data del volo è già passata.",
        flightTimeRequired: "Inserisca l'orario del volo.",
        epaTooSoon: "L'EPA va prenotato almeno 5 ore prima del volo.",
        originCityRequired: "Inserisca la città di provenienza.",
        locationRequired: "Scelga dove apporre il visto.",
        airportRequired: "Scelga l'aeroporto di arrivo.",
        flightNumberInvalid: "Inserisca il numero di volo, es. TG931.",
        arrivalDateRequired: "Inserisca la data di arrivo.",
        arrivalTooSoon: "L'arrivo deve essere il {{date}} o dopo (7 giorni da oggi).",
        arrivalTimeRequired: "Inserisca l'orario di arrivo.",
        preferredDateRequired: "Scelga una data preferita.",
        weekend: "L'Immigrazione è chiusa nel fine settimana. Scelga dal lunedì al venerdì.",
        appointmentTooSoon: "Scelga il {{date}} o dopo (5 giorni lavorativi da oggi).",
        periodRequired: "Scelga mattina o pomeriggio.",
        alternativeInvalid: "La seconda scelta deve essere un giorno lavorativo, dal {{date}} in poi.",
        tm30Required: "Carichi una copia del suo TM30.",
        passportRequired: "Alleghi una copia del suo passaporto.",
        bankRequired: "Scelga una banca.",
        cityRequired: "Scelga una città.",
      },
    },
  },

  wizard: {
    applicationSteps: "Fasi della domanda",
    step: "Passo",
    of: "di",
    readOnlyBanner: "Questa domanda è stata inviata. Contatta l'assistenza per richiedere modifiche.",
    readOnlySupportLink: "Richiedi una modifica",
    backgroundCheckTitle: "Domanda in esame",
    backgroundCheckBody: "La tua domanda è attualmente in fase di esame da parte del nostro team e delle autorità tailandesi competenti. In questa fase, la tua domanda non può essere annullata né modificata. Per qualsiasi domanda, contatta il nostro team di assistenza.",
    backgroundCheckExpected: "Potresti ricevere la tua lettera di approvazione approssimativamente entro:",
    backgroundCheckNote: "* Si tratta di una tempistica stimata basata su un'elaborazione tipica di 4–8 settimane. Non è garantita.",
    backgroundCheckContact: "Per domande, contatta il nostro team:",
    steps: {
      package: "Programma",
      passport: "Passaporto",
      personalInfo: "Dati personali",
      address: "Indirizzo",
      visa: "Visto e ingresso",
      documents: "Documenti",
      review: "Verifica",
    },
    stepDescriptions: {
      package: "Seleziona il programma di adesione Thailand Elite",
      passport: "Carica e verifica il tuo passaporto",
      personalInfo: "Completa i tuoi dati personali",
      address: "Il tuo indirizzo di residenza e dati di contatto",
      visa: "Stato attuale del visto e dell'ingresso",
      documents: "Carica e firma i documenti richiesti",
      review: "Verifica e invia la tua domanda",
    },
  },

  // ── Next Member ──────────────────────────────────────────────────────────
  nextMember: {
    title: "Domanda Membro Associato",
    subtitle: "Stai facendo domanda come membro associato nell'ambito di un'adesione principale esistente.",
    badge: "Membro associato",
    addButton: "Aggiungi membro associato",
    relationship: "Rapporto con il membro principale",
    selectRelationship: "Seleziona il rapporto…",
    relationships: {
      spouse: "Coniuge",
      child: "Figlio/a",
      parent: "Genitore",
      adopted_child: "Figlio/a adottivo/a",
      civil_union: "Partner di unione civile",
    },
    coreApplication: "Domanda principale",
    additionalFee: "Quota membro aggiuntivo",
    promoLabel: "Tariffa promozionale",
    regularFee: "Tariffa normale",
    promoUntil: "Valida fino al 31/12/2026",
    perMember: "/membro",
    existingNextMember: "Domanda membro associato",
  },

  package: {
    title: "Scegli il programma",
    subtitle: "Seleziona il programma di adesione Thailand Elite più adatto a te.",
    selected: "Selezionato",
    selectPackage: "Seleziona programma",
    years: "anni",
    perYear: "all'anno",
    includes: "Include",
    familyOption: "Opzione famiglia disponibile",
  },

  passport: {
    title: "Verifica passaporto",
    subtitle: "Carica la pagina dati del tuo passaporto per la verifica OCR.",
    uploadTitle: "Carica foto passaporto",
    uploadDesc: "Foto o scansione della pagina dati del passaporto (JPG, PNG, PDF — max 10 MB)",
    uploadHint: "Tocca per caricare o scattare una foto",
    extractTitle: "Estrai i dati",
    extractDesc: "Clicca per compilare i tuoi dati automaticamente con l'IA — richiede qualche secondo",
    retakePhoto: "Rifai / Ricarica",
    passportNumber: "Numero passaporto",
    surname: "Cognome",
    givenName: "Nome/i",
    nationality: "Nazionalità",
    dateOfBirth: "Data di nascita",
    sex: "Sesso",
    dateOfIssue: "Data di rilascio",
    dateOfExpiry: "Data di scadenza",
    placeOfBirth: "Luogo di nascita",
    mrz: "Zona leggibile dalla macchina (MRZ)",
    extractedData: "Dati estratti",
    verifyAndContinue: "Verifica e continua",
    lowConfidenceWarning: "Alcuni campi non sono stati letti chiaramente. Verifica prima di continuare.",
    expiryWarning: "Il passaporto deve avere almeno 6 mesi di validità residua per fare domanda.",
    expiryModalTitle: "Problema di validità del passaporto",
    expiryModalDesc: "La validità del passaporto deve essere superiore a 1 anno dalla data di domanda. Rinnovare il passaporto prima di fare domanda.",
    expiryModalCta: "Ho capito",
    // Scan requirements
    scanRequirements: "Requisiti della scansione",
    scanReqColor: "Scansione a colori — niente bianco e nero",
    scanReqEdges: "Tutti e quattro i bordi visibili",
    scanReqResolution: "Alta risoluzione, tutto il testo leggibile",
    scanReqFocus: "Non sfocata o fuori fuoco",
    gallery: "Galleria",
    scanning: "Scansione in corso…",
    uploadDifferentFile: "Carica un file diverso",
    fileFormatHint: "JPG, PNG o PDF · max 10 MB",
    // Gender options
    male: "Maschio",
    female: "Femmina",
    // Placeholders
    cityOrTown: "Città o paese",
    country: "Paese",
    asShownOnPassport: "Come riportato sul passaporto",
    ifApplicable: "Se applicabile",
    // Toast messages
    passportUploaded: "Passaporto caricato",
    passportUploadedDesc: "Clicca su 'Scansiona e precompila con IA' per estrarre i tuoi dati.",
    passportScanned: "Passaporto scansionato ✓",
    passportScannedDesc: "Rivedi i dati estratti qui sotto.",
    qualityIssuesDetected: "Rilevati problemi di qualità",
    scanUnavailable: "Scansione non disponibile",
    scanUnavailableDesc: "Compila manualmente i tuoi dati qui sotto.",
    applicationAlreadyExists: "La domanda esiste già",
    applicationAlreadyExistsDesc: "Una domanda precedente per {{name}} è già stata avviata. Riprendila oppure contatta l'assistenza se si tratta di un nuovo richiedente.",
    // OCR quality issues
    blurryImage: "Immagine sfocata",
    reflectionDetected: "Riflesso / abbagliamento rilevato",
    glareOnPassport: "Abbagliamento sul passaporto",
    imageCropped: "Immagine tagliata — riscansiona mostrando l'intero passaporto",
    bioPageComplete: "Pagina dati completa",
    mrzReadable: "MRZ leggibile",
    // Signature section
    signaturePage: "Pagina della firma",
    signatureOptional: "Facoltativo",
    signaturePageRequired: "Carica la pagina del passaporto che contiene la tua firma autografa, se non presente nella pagina dati.",
    signatureDetectedOnBio: "La tua firma è stata rilevata nella pagina dati. Puoi anche caricare la pagina della firma separata, se il tuo passaporto ne ha una.",
    signatureDetectedConfirm: "Firma rilevata nella pagina dati del passaporto ✓",
    signatureDetectedNote: "Se il tuo passaporto ha anche una pagina dedicata alla firma (comune nei passaporti francesi, italiani e tedeschi), puoi caricarla qui sotto.",
    signatureNotCorrect: "Non corretto — nessuna firma su questa pagina",
    noSignatureOnBioPage: "Nessuna firma trovata nella pagina dati",
    noSignatureOnBioPageNote: "Alcuni passaporti non includono una firma nella pagina dati — carica la pagina che contiene la tua firma. È obbligatorio per i passaporti di: <strong>Singapore, Filippine, Malesia, Indonesia, Svezia, Emirati Arabi Uniti, Arabia Saudita, Qatar, Kuwait, Bahrein, Oman</strong> e per la maggior parte dei passaporti dei minori.",
    signaturePageUploaded: "Pagina della firma caricata",
    uploadSignaturePageOptional: "Carica la pagina della firma (facoltativo)",
    uploadSignaturePage: "Carica la pagina della firma",
    replace: "Sostituisci",
    pdf: {
      label: "PDF del passaporto",
      openPreview: "Apri anteprima PDF",
      detectedNote: "PDF rilevato — la pagina del passaporto viene letta direttamente dal PDF.",
    },
    ocrCooldown: "Attendi qualche secondo prima di riprovare.",
  },

  personalInfo: {
    title: "Dati personali",
    subtitle: "Rivedi e completa il tuo profilo e i dettagli della domanda.",
    profilePhoto: {
      title: "Foto tessera",
      desc: "Una foto recente e nitida del tuo viso (formato tessera). Richiesta per la tua carta di socio.",
      uploadButton: "Carica foto",
      changeButton: "Cambia foto",
      takePhoto: "Scatta foto",
      saved: "Salvata",
      photoSaved: "Foto salvata ✓",
      photoUploadFailed: "Caricamento della foto fallito",
      removeBackgroundAi: "Rimuovi lo sfondo con l'IA",
      removeBackgroundNote: "Lo sfondo verrà sostituito con il bianco — applicato al prossimo caricamento.",
    },
    identity: {
      sectionTitle: "Identità",
      title: "Titolo",
      givenName: "Nome",
      middleName: "Secondo nome",
      surname: "Cognome",
      nameOnCard: "Nome sulla tessera Elite",
      nameOnCardHint: "Nome che apparirà sulla tessera di socio",
      dateOfBirth: "Data di nascita",
      gender: "Sesso / Genere",
      occupation: "Professione",
      businessIndustry: "Settore professionale",
    },
    applicationDetails: {
      sectionTitle: "Dettagli domanda",
      sectionDesc: "Precompilato dalla scansione del passaporto. I dati del passaporto vengono applicati automaticamente.",
      fromPassport: "Dal passaporto",
      nationality: "Nazionalità",
      placeOfBirth: "Luogo di nascita",
      countryOfBirth: "Paese di nascita",
    },
    nationalityCheck: {
      question: "Possiedi attualmente un'altra nazionalità o cittadinanza?",
      otherNationality: "Altra nazionalità",
      passportsIntro: "Dichiara ogni altro passaporto e nazionalità che possiedi. Questi dati compaiono nella Dichiarazione di passaporti e nazionalità multiple (pagina 2 del modulo di domanda), che firmerai.",
      passportHeading: "Altro passaporto {{n}}",
      passportNumber: "Numero di passaporto",
      issueDate: "Data di rilascio",
      expiryDate: "Data di scadenza",
      nameOnPassport: "Nome completo su questo passaporto (se diverso)",
      addPassport: "Aggiungi un altro passaporto",
      passportRequired: "Inserisci la nazionalità e il numero del tuo altro passaporto.",
      requiredDocsTitle: "Documenti richiesti per chi ha più nazionalità:",
      reqDoc1: "Passaporto/i della nazionalità d'origine, più eventuali passaporti precedenti se nome o cognome sono cambiati.",
      reqDoc2: "Documento/i ufficiale/i di rinuncia alla nazionalità d'origine (se applicabile).",
      reqDoc3: "Documenti che attestino il reddito e l'origine dei fondi usati per l'adesione.",
      reqDoc4: "Prova di residenza permanente in Thailandia o all'estero relativa agli ultimi 6 mesi.",
      mismatchTitle: "Il paese di nascita è diverso dalla tua nazionalità",
      mismatchIntro: "Abbiamo inoltre notato che il tuo paese di nascita è diverso dal tuo paese di cittadinanza, mentre hai indicato di possedere una sola nazionalità.",
      mismatchBody: "Ti informiamo che le autorità dell'Immigrazione applicano requisiti rigorosi per l'apposizione del visto e possono richiedere documentazione aggiuntiva. Se possiedi la doppia nazionalità, devi dichiararla. Se hai rinunciato a una nazionalità precedente, prepara i relativi documenti giustificativi.",
      listTitle: "Se applicabile, fornisci:",
      doc1: "Una copia leggibile del tuo secondo passaporto.",
      doc2: "Una copia del certificato di cittadinanza o di altra documentazione che mostri come hai ottenuto la cittadinanza attuale, insieme a una breve spiegazione.",
      doc3: "Una copia del certificato di rinuncia se in passato possedevi un'altra nazionalità a cui hai rinunciato.",
      explanationLabel: "Breve spiegazione (facoltativa)",
      explanationPlaceholder: "es. Nato in Brasile, naturalizzato italiano nel 2010, cittadinanza brasiliana rinunciata nel 2012.",
      uploadTitle: "Documenti giustificativi",
      uploadDesc: "PDF, JPG o PNG — max 10 MB ciascuno.",
    },
    contact: {
      phone: "Telefono",
      phonePlaceholder: "+66 XX XXX XXXX",
      email: "Indirizzo e-mail",
      emailHint: "Usato per la tua domanda. Può differire dall'e-mail di accesso.",
    },
    sharedProfile: "Profilo condiviso",
    fillAllRequiredFields: "Compila tutti i campi obbligatori",
  },

  address: {
    title: "Indirizzo",
    subtitle: "Il tuo indirizzo di residenza attuale.",
    currentAddress: "Indirizzo attuale",
    street: "Via e numero civico",
    streetHint: "Completamento automatico OpenStreetMap",
    startTyping: "Inizia a digitare l'indirizzo…",
    city: "Città",
    state: "Regione / Provincia",
    country: "Paese",
    postalCode: "Codice postale",
    thaiAddress: "Indirizzo in Thailandia",
    haveThaiAddress: "Ho un indirizzo in Thailandia",
    accommodationType: "Tipo di alloggio",
    province: "Provincia",
    district: "Distretto",
    subDistrict: "Sottoistretto",
    thaiTelephone: "Telefono (Thailandia)",
    thaiPhoneNote: "Numero di telefono thailandese (senza lo 0 iniziale)",
    validationError: "Inserisci via, città e paese",
  },

  visa: {
    title: "Stato visto e ingresso",
    subtitle: "Il tuo visto tailandese attuale e le informazioni sull'ingresso.",
    currentVisa: "Visto tailandese attuale",
    hasThaiVisa: "Sei attualmente in possesso di un visto tailandese?",
    visaType: "Tipo di visto",
    visaExpiry: "Scadenza visto",
    uploadVisaPage: "Foto della pagina visto",
    uploadVisaBtn: "Carica pagina visto",
    arrivalStamp: "Timbro d'ingresso",
    hasArrivalStamp: "Sei attualmente in possesso di un timbro d'ingresso?",
    stampExpiry: "Scadenza timbro d'ingresso",
    uploadStampPage: "Foto della pagina con timbro",
    uploadStampBtn: "Carica pagina con timbro",
    passportStatus: "Stato passaporto",
    blankVisaPages: "Più di 3 pagine visto vuote nel passaporto?",
    blankYes: "Sì — più di 3",
    blankNo: "No — 3 o meno",
    overstayCount: "Volte in cui hai superato il permesso di soggiorno in Thailandia (ultimi 3 anni)",
    overstayNever: "0 — Mai",
    otherVisaOption: "Altro (specificare)",
    otherVisaLabel: "Specifica il tuo visto",
    otherVisaPlaceholder: "Codice breve, es. Non-O, SMART-T",
    edVisa: {
      sectionTitle: "Cronologia visto studio (ED)",
      sectionDesc: "Dichiarazione obbligatoria per la valutazione dell'idoneità Thailand Elite.",
      question: "Hai avuto un visto studio (ED) negli ultimi 5 anni o nel passaporto attuale?",
      warningTitle: "Documenti di supporto aggiuntivi richiesti",
      warningDesc: "L'accettazione dei candidati con precedenti di visto studio è subordinata alla presentazione dei seguenti documenti. La mancanza di documenti potrebbe comportare un rifiuto.",
      doc1: "Licenza di istituzione scolastica (สช.2 / OBEC / OPEC)",
      doc2: "Registrazione scolastica (ร.2)",
      doc3: "Certificazione studentesca rilasciata dalla scuola",
      doc4: "Registro accademico, pagelle e registro presenze",
      doc5: "Foto delle attività di classe",
      doc5Optional: "(facoltativo — da caricare in seguito se non disponibile)",
      acknowledgementForm: "Modulo di riconoscimento",
      acknowledgementFormDesc: "Scarica, compila e carica insieme ai documenti di supporto",
      uploadTitle: "Carica documenti di supporto",
      uploadDesc: "PDF, JPG o PNG — puoi caricare più file. Salvati in sicurezza nella tua domanda.",
    },
  },

  visaReminder: {
    title: "Importante — Mantieni un visto valido",
    body: "Mantieni sempre un visto valido se ti trovi in Thailandia. L'invio di questa domanda non concede alcuna estensione del soggiorno né autorizzazione a rimanere in Thailandia. Se ti trovi attualmente in Thailandia, assicurati che il tuo visto rimanga valido per tutta la durata del processo di domanda.",
  },

  documents: {
    title: "Documenti",
    subtitle: "Scarica, firma e carica i tuoi moduli di domanda.",
    applicationForm: {
      title: "Modulo di domanda",
      desc: "Scarica il modulo precompilato, firmalo digitalmente, poi caricalo.",
      download: "Scarica PDF precompilato",
      signDigitally: "Firma digitalmente",
      signatureCapture: "Acquisisci firma",
      signatureCaptureDesc: "Disegna la tua firma qui sotto",
      clear: "Cancella",
      save: "Salva firma",
      appliedTo: "Applicata a tutte le pagine",
      uploadSigned: "Carica modulo firmato",
    },
    pdpaForm: {
      title: "Modulo consenso PDPA",
      desc: "Consenso alla legge sulla protezione dei dati personali. Scarica, firma e carica.",
      download: "Scarica modulo PDPA",
      signDigitally: "Firma digitalmente",
      uploadSigned: "Carica modulo firmato",
    },
    uploadStatus: "Stato caricamento",
    viewDocument: "Visualizza documento caricato",
    downloadDocument: "Scarica PDF firmato",
    signingComplete: "Firma completata — carica per salvare",
    remaining: "rimanenti",
    requiredDocuments: "Documenti richiesti",
    continueToReview: "Continua alla verifica",
    blankForm: "Modulo in bianco",
    blankAddendum: "Addendum promozionale in bianco",
    downloadLabel: "Scarica",
    reprefill: "Ricompila",
    // Toast messages for DocumentsStep
    applicationFormPrefilled: "Modulo di domanda precompilato",
    applicationFormPrefilledDesc: "Scaricato! Firma ogni pagina, poi caricala o firma digitalmente.",
    prefillFailed: "Precompilazione fallita",
    applicationFormSigned: "Modulo di domanda firmato e salvato ✓",
    signingFailed: "Firma fallita",
    applicationFormUploaded: "Modulo di domanda caricato ✓",
    pdpaFormSigned: "Modulo consenso PDPA firmato e salvato ✓",
    pdpaFormUploaded: "Modulo consenso PDPA caricato ✓",
    documentUploaded: "Documento caricato ✓",
    uploaded: "Caricato ✓",
    translationUploaded: "Traduzione caricata ✓",
    uploadTranslation: "Carica traduzione",
    relationshipProof: {
      title: "Documenti comprovanti il rapporto",
      subtitle: "Carica i documenti ufficiali che comprovano il tuo rapporto con il membro principale.",
      marriageCert: "Certificato di matrimonio",
      birthCert: "Certificato di nascita",
      adoptionCert: "Certificato di adozione",
      civilUnionCert: "Certificato di unione civile",
      notInEnglish: "Questo documento non è in inglese",
      certifiedTranslation: "Traduzione certificata in inglese",
    },
    signatureCapture: {
      title: "Firma elettronica (facoltativa)",
      subtitle: "Disegna o carica la tua firma da applicare a tutti i documenti della domanda.",
      saved: "Firma salvata",
      willBeApplied: "Verrà applicata a tutti i documenti",
      confirm: "Ho capito e desidero firmare digitalmente",
      disclaimer1: "Il richiedente deve firmare personalmente tutte le pagine della domanda. Se il richiedente ha meno di 20 anni, deve firmare anche il rappresentante legale.",
      disclaimer2: "Tutte le firme devono corrispondere esattamente alla firma sul passaporto.",
      disclaimer3: "⚠️ Consentiamo le firme digitali, ma tieni presente che in alcuni casi Thailand Privilege Card potrebbe richiedere una copia interamente stampata, firmata a mano e scansionata di tutte le pagine. Se disponi di una stampante e di uno scanner, ti consigliamo vivamente di stampare e firmare a mano.",
      options: {
        upload: {
          title: "Carica firma",
          desc: "Carica un'immagine della tua firma",
          instruction: "Clicca o trascina qui un file immagine",
          enhancing: "Miglioramento in corso…",
          clickToUpload: "Clicca per caricare",
        },
        passport: {
          title: "Usa la firma del passaporto",
          desc: "Estrai la tua firma dalla scansione del passaporto caricata",
          passportRef: "Scansione del passaporto",
          notFound: "Nessuna scansione del passaporto trovata — carica prima il tuo passaporto",
          instruction: "Clicca per estrarre la firma dal passaporto",
          uploadBtn: "Estrai dal passaporto",
        },
        draw: {
          title: "Disegna firma",
          desc: "Disegna la tua firma usando il mouse o il dito",
        },
      },
    },
  },

  review: {
    title: "Verifica e invio",
    subtitle: "Rivedi la tua domanda prima di inviarla.",
    applicationSummary: "Riepilogo domanda",
    membershipPackage: "Programma di adesione",
    fullName: "Nome completo",
    nationality: "Nazionalità",
    dateOfBirth: "Data di nascita",
    passportNo: "N° passaporto",
    passportExpiry: "Scadenza passaporto",
    occupation: "Professione",
    country: "Paese",
    city: "Città",
    phone: "Telefono",
    email: "E-mail",
    remaining: "rimanenti",
    requiredDocuments: "Documenti richiesti",
    passportPhoto: "Foto passaporto / documento d'identità",
    profilePhoto: "Foto profilo",
    applicationFormSigned: "Modulo di domanda (firmato)",
    pdpaFormSigned: "Modulo consenso PDPA (firmato)",
    missingDocsWarning: "Completa tutti i documenti richiesti al passo 6 prima di inviare.",
    // Validation issues
    validation: {
      fullNameMissing: "Nome completo mancante",
      passportNoMissing: "Numero di passaporto mancante",
      passportExpiryMissing: "Data di scadenza del passaporto mancante",
      passportValidityWarning: "La validità del passaporto deve essere superiore a 1 anno dalla data di domanda",
      nationalityMissing: "Nazionalità mancante",
      otherNationalityMissing: "Domanda sulla seconda nazionalità senza risposta",
      phoneMissing: "Numero di telefono mancante",
      countryMissing: "Paese di residenza mancante",
      cityMissing: "Città mancante",
      missingInfoTitle: "Informazioni mancanti — completa prima di inviare",
      goTo: "Vai a",
      completeBeforeSubmitting: "Completa le informazioni mancanti qui sopra prima di inviare",
      accountFlaggedTitle: "Il tuo account è stato segnalato",
      uploadFlagged: "Uno dei tuoi caricamenti non rispetta le nostre regole sui documenti, quindi il tuo account è stato segnalato per una verifica. Se si tratta di un errore, inviaci un messaggio e il nostro team controllerà.",
      contactUs: "Inviaci un messaggio",
      passportNotGenuine: "Il file caricato non è una pagina dati del passaporto leggibile (la pagina con la tua foto e le due righe di codice in basso). Carica una copia nitida del tuo vero passaporto.",
      passportDataMismatch: "Alcuni dati non corrispondono al passaporto scansionato: {{fields}}. Correggili in modo che corrispondano esattamente al passaporto.",
      mismatchConfirm: "I miei dati sono corretti — fate verificare il mio passaporto dal team",
      fieldPassportNo: "numero di passaporto",
      fieldDob: "data di nascita",
      fieldExpiry: "data di scadenza del passaporto",
    },
    survey: {
      title: "Sondaggio",
      howDidYouLearn: "Come hai scoperto Thailand Elite?",
      mainReason: "Motivo principale della domanda?",
      expectation: "Cosa ti aspetti dall'adesione?",
    },
    agreement: "Confermo che tutte le informazioni fornite sono accurate, complete e autentiche. Acconsento al trattamento dei miei dati personali e documenti — incluso il riconoscimento OCR del passaporto e la verifica della firma assistiti dall'IA — da parte di Dreamond e Thailand Privilege Card Co., Ltd. ai fini della mia domanda di adesione. Comprendo che non è richiesto alcun pagamento fino all'approvazione ufficiale della domanda e che qualsiasi pagamento deve essere effettuato esclusivamente a Thailand Privilege Card Co., Ltd. sulla base della loro fattura ufficiale. Ho letto e accetto i",
    termsAndConditions: "Termini e Condizioni",
    and: "e la",
    privacyPolicy: "Politica sulla privacy",
    noPaymentNote: "nessun pagamento richiesto fino all'approvazione ufficiale",
    missingDocumentsError: "Documenti mancanti",
    missingDocumentsErrorDesc: "Carica tutti i documenti richiesti prima di inviare.",
    submittedTitle: "Domanda inviata!",
    submittedDesc: "Esamineremo la tua domanda e ti risponderemo.",
    submissionFailed: "Invio fallito",
  },

  // ── Post-Approval Screens ─────────────────────────────────────────────────
  screens: {
    common: {
      contactSupport: "Per domande, contatta il nostro team:",
    },
    approved: {
      title: "Congratulazioni! La tua domanda è stata approvata",
      message: "Controlla la tua email per la lettera di approvazione e la fattura. Devi completare il pagamento entro 30 giorni per attivare la tua adesione.",
      uploadTitle: "Carica la prova di pagamento",
      uploadHint: "Ricevuta del bonifico bancario, screenshot o PDF (max 10 MB)",
      uploadButton: "Carica prova di pagamento",
      uploadSuccess: "Prova di pagamento caricata",
      uploadSuccessDesc: "Il reparto finanziario verificherà il tuo pagamento, di norma entro circa 3 giorni lavorativi.",
      uploadedConfirmation: "Prova di pagamento caricata — in fase di verifica",
      cardPaymentTitle: "Paga con carta di credito",
      cardPaymentHint: "Richiedi un link di pagamento sicuro al reparto finanziario",
      requestLink: "Richiedi link di pagamento con carta di credito",
      payByCard: "Paga con carta di credito",
      linkRequested: "Richiesta inviata",
      linkRequestedDesc: "Il reparto finanziario ti invierà a breve un link di pagamento.",
      note: "Se hai già caricato la tua prova di pagamento, non è necessaria alcuna ulteriore azione.",
      proofRejectedTitle: "Non siamo riusciti a verificare la tua prova di pagamento",
      proofRejectedHelp: "Carica qui sotto una nuova prova di pagamento. Per qualsiasi domanda, rispondi alla nostra email o contattaci.",
    },
    paymentPending: {
      title: "Pagamento in fase di verifica",
      message: "La tua prova di pagamento è stata ricevuta e inviata al reparto finanziario per la verifica. La verifica richiede di norma circa 3 giorni lavorativi, poi circa 4 giorni lavorativi per l'attivazione dell'adesione e la lettera di benvenuto.",
      verifying: "Verifica del pagamento in corso…",
      uploaded: "Caricata",
      expected: "Verifica prevista",
      uploadDate: "Data di caricamento",
      expectedDate: "Prevista entro",
      activationDate: "Attivazione intorno al",
      note: "Sono tempi indicativi (circa 7 giorni lavorativi in totale) e possono variare in base a quando il pagamento viene accreditato e al carico di lavoro del reparto finanziario.",
      verifiedTitle: "Pagamento verificato",
      verifiedMessage: "Il tuo pagamento è stato verificato. La tua adesione è in fase di emissione: la lettera di benvenuto arriva di norma entro circa 4 giorni lavorativi.",
      addTitle: "Aggiungi un altro documento di pagamento",
      addHint: "Se il reparto finanziario richiede altro, o hai un estratto conto, un avviso di addebito o uno SWIFT MT103, aggiungilo qui. Tutti i documenti vengono raccolti insieme per la verifica.",
      addButton: "Aggiungi un documento",
      added: "Documento aggiunto",
      documentsTitle: "Documenti inviati",
    },
    paymentDone: {
      title: "Pagamento convalidato",
      message: "Il tuo pagamento è stato confermato dal reparto finanziario. Riceverai a breve via email la tua lettera di benvenuto e le informazioni sulla tessera di socio.",
      verified: "Pagamento verificato ✓",
      nextStepsTitle: "Quali sono i prossimi passi?",
      step1: "Riceverai la tua lettera di benvenuto via email",
      step2: "La tua tessera di socio verrà preparata",
      step3: "Ti contatteremo per l'appuntamento di apposizione del visto",
      package: "La tua adesione",
    },
    prePayment: {
      title: "Avviso importante prima del pagamento",
      intro: "Non effettuare alcun pagamento se ricorre una delle seguenti condizioni.",
      conditions: [
        {
          title: "Validità del timbro d'ingresso",
          detail: "Il permesso di soggiorno indicato sul timbro d'ingresso del passaporto deve essere valido. Il richiedente con un overstay registrato durante il soggiorno in corso non può in alcun caso ottenere il visto Thailand Privilege.",
        },
        {
          title: "Visto Non-Immigrant O (Volontariato)",
          detail: "Il richiedente che detenga attualmente, o abbia detenuto in qualsiasi momento, un visto Non-Immigrant di tipo O (Volontariato) non può in alcun caso ottenere il visto Thailand Privilege.",
        },
        {
          title: "Visto Non-Immigrant MT o ED",
          detail: "Il richiedente che detenga attualmente un visto Non-Immigrant MT (cure mediche) privo della relazione ospedaliera o del certificato medico richiesto, oppure un visto Non-Immigrant ED (studio) privo del documento ufficiale rilasciato dall'Office of Basic Education Commission (OBEC) e della relativa documentazione, non può in alcun caso ottenere il visto Thailand Privilege.",
        },
      ],
      warning: "Qualora ricorra una delle condizioni sopra indicate, Thailand Privilege Card Co., Ltd. si riserva il diritto di trattenere la quota associativa senza alcun rimborso.",
      rulesTitle: "Condizioni di pagamento",
      rules: [
        { text: "La quota associativa deve essere versata in un'unica transazione, in conformità all'Anti-Money Laundering Act, B.E. 2542 (1999) e successive modifiche. Anche un bonifico da mobile banking deve corrispondere all'intero importo in un'unica operazione." },
        { text: "L'importo ricevuto da Thailand Privilege Card Co., Ltd. deve corrispondere all'intera quota associativa. Tutte le spese bancarie, le commissioni delle banche intermediarie, le commissioni di agenzia e ogni altro onere di trasferimento restano a carico del richiedente." },
        { text: "La lettera di approvazione e la fattura hanno validità di 30 giorni dalla data di emissione. Una domanda scaduta è soggetta a un nuovo controllo dei precedenti." },
        { text: "I pagamenti effettuati dopo la scadenza indicata in fattura non saranno accettati e non potranno beneficiare di alcuna offerta promozionale." },
        { text: "Le carte American Express non sono accettate." },
      ],
      doubt: "Se non è certo che una di queste condizioni La riguardi, ci contatti prima di pagare. Possiamo esaminare preventivamente la Sua pratica.",
    },

    visaAffix: {
      title: "Richiedere l'apposizione del visto",
      intro: "Invii la richiesta al nostro team: alleghiamo i documenti già presenti nella Sua pratica, la trasmettiamo al Member Contact Center e seguiamo la prenotazione dell'appuntamento.",
      locationLabel: "Luogo desiderato per l'apposizione",
      locations: {
        chaengWattana: "Ufficio immigrazione di Chaeng Wattana, Bangkok",
        suvarnabhumi: "Aeroporto di Suvarnabhumi, all'arrivo",
        phuket: "Aeroporto internazionale di Phuket, all'arrivo",
        chiangMai: "Aeroporto internazionale di Chiang Mai, all'arrivo",
        overseas: "Fuori dalla Thailandia (e-Visa tramite una rappresentanza thailandese)",
      },
      noticeThailand: "Gli appuntamenti richiedono un preavviso di 5-7 giorni lavorativi e dipendono dalla disponibilità di un Elite Personal Liaison.",
      noticeOverseas: "L'e-Visa viene rilasciato tramite il portale ufficiale del governo thailandese. Sono previsti 15-30 giorni lavorativi dalla presentazione.",
      dateLabel: "Data desiderata",
      flightLabel: "Volo di arrivo",
      flightPlaceholder: "es. TG911, 14 ott.",
      documentsLabel: "Documenti nella Sua pratica",
      documentsHint: "Selezioni ciò che dobbiamo allegare. Per impostazione predefinita è incluso tutto.",
      documentTypes: {
        passport_photo: "Passaporto",
        application_form: "Modulo di domanda",
        consent_form: "Modulo di consenso",
        payment_proof: "Prova di pagamento",
      },
      submit: "Comporre la richiesta",
      mccTitle: "Member Contact Center",
      mccHint: "Per organizzare l'appuntamento autonomamente, contatti direttamente l'MCC indicando il Suo numero di socio.",
      email: {
        subject: "Richiesta di apposizione del visto",
        intro: "Desidero richiedere un appuntamento per l'apposizione del visto Privilege Entry.",
        member: "Socio",
        card: "N. di socio",
        package: "Programma",
        location: "Luogo desiderato",
        preferredDate: "Data desiderata",
        flight: "Volo di arrivo",
        documentsHeld: "Si prega di allegare dalla mia pratica",
        noneSelected: "Nessun documento selezionato",
        notSpecified: "Non specificato",
        closing: "Cordiali saluti.",
      },
    },

    active: {
      title: "Benvenuto in Thailand Elite!",
      subtitle: "Congratulazioni — ora sei un membro ufficiale Thailand Elite.",
      cardNo: "N° di socio",
      package: "Programma",
      validFrom: "Valida dal",
      validUntil: "Valida fino al",
      requestVisaAffix: "Richiedi apposizione del visto",
      memberArea: "Dashboard membri",
    },
    rejected: {
      title: "Domanda non approvata",
      titleCancelled: "Domanda annullata",
      message: "Purtroppo la tua domanda non è stata approvata in questo momento. Per qualsiasi domanda su questa decisione, contatta il nostro team di assistenza.",
      messageCancelled: "Questa domanda è stata annullata. Se desideri fare nuovamente domanda, puoi avviarne una nuova.",
      messageInactive: "Questa domanda è stata chiusa dopo un lungo periodo di inattività. Tutto ciò che hai inserito è salvato: puoi riprendere da dove avevi lasciato.",
      resume: "Riprendi la mia domanda",
      resumedToast: "Bentornato! La tua domanda è di nuovo aperta.",
      resumeFailed: "Non è stato possibile riaprire questa domanda. Inviaci un messaggio.",
      info: "Puoi avviare una nuova domanda se desideri fare nuovamente richiesta.",
      startNew: "Avvia nuova domanda",
    },
  },

  auth: {
    login: {
      title: "Portale Membri",
      subtitle: "Accedi al tuo account",
      email: "Email",
      continueWithEmail: "Continua con l'Email",
      sendingLink: "Invio link…",
      noPasswordNote: "Ti invieremo un link di accesso sicuro — nessuna password necessaria.",
      noAccount: "Non hai un account?",
      createOne: "Creane uno",
      checkEmailTitle: "Controlla la tua email",
      checkEmailDesc: "Abbiamo inviato un link di accesso a <strong>{{email}}</strong>. Clicca il link per accedere al tuo account.",
      didntReceive: "Non l'hai ricevuto?",
      tryAgain: "Riprova",
      accountDisabledTitle: "Account Disabilitato",
      accountDisabledMsg: "Il tuo account è stato disabilitato.",
      accountDisabledReason: "Motivo:",
      accountDisabledContact: "Se credi sia un errore, contattaci a",
    },
    register: {
      title: "Crea Account",
      subtitle: "Inizia il tuo viaggio Thailand Elite",
      firstName: "Nome",
      lastName: "Cognome",
      email: "Email",
      phoneNumber: "Numero di Telefono",
      searchCountry: "Cerca paese…",
      continueWithEmail: "Continua con l'Email",
      sendingLink: "Invio magic link…",
      noPasswordNote: "Ti invieremo un link sicuro per verificare la tua email e accedere — nessuna password necessaria.",
      alreadyHaveAccount: "Hai già un account?",
      signIn: "Accedi",
      checkEmailTitle: "Controlla la tua email",
      checkEmailDesc: "Abbiamo inviato un magic link a <strong>{{email}}</strong>. Clicca il link nella tua email per accedere e completare la tua registrazione.",
      didntReceive: "Non l'hai ricevuto?",
      tryAgain: "Riprova",
    },
  },
};
